import { CARD_BACKGROUND_COUNT } from "./cardBackgrounds.js";
import { COLORWAY_COUNT } from "./colorway.js";
import { encode, FINISHES, PATTERN_VARIANTS, type SkinSpec } from "./spec.js";

export { CODE_LENGTH, isValidCode } from "./spec.js";

/**
 * Roll a uniformly-random spec across every axis. Each field draws
 * independently from its declared range. Used by the grid sandbox to
 * paint a wall of distinct cards; the tuner's roll uses a separate
 * weighted distribution to bias toward "feels right" cosmetics.
 */
export function rollSpec(rand: () => number): SkinSpec {
  return {
    pattern: {
      index: Math.floor(rand() * PATTERN_VARIANTS),
      offsetX: rand(),
      offsetY: rand(),
      scale: 0.5 + rand() * 2.5,
      overlayAlpha: rand(),
    },
    cardBackground: Math.floor(rand() * CARD_BACKGROUND_COUNT),
    colorway: Math.floor(rand() * COLORWAY_COUNT),
    tint: {
      hue: -1 + rand() * 2,
      saturation: rand() * 2,
      brightness: rand() * 2,
    },
    finish: FINISHES[Math.floor(rand() * FINISHES.length)] ?? "matte",
    finishStrength: rand(),
    cellSize: 1 + rand() * 7,
    coverageBias: rand(),
    depth: rand() * 1.5,
    wear: rand(),
  };
}

export function rollCode(rand: () => number): string {
  return encode(rollSpec(rand));
}
